export const convertLocationString = (location: string): ILocation => {
  const lng = location?.split(' ')[1].replace('(', '');
  const lat = location?.split(' ')[2].replace(')', '');

  return {
    lat: Number(lat),
    lng: Number(lng),
  };
};
